<rt-button
  variant="plain"
  #dropdownTrigger="rtOverlayOrigin"
  rt-overlay-origin
  [pressed]="sharingDropdown.open"
  (click)="onShareClick()"
  data-cy="candidate-sharing-button"
>
  <rt-icon prefix name="person-add" />
  {{ 'app.common.share' | translate }}
  @if (showShareSum) {
    <rt-badge
      rtTooltip
      [rtTooltipTemplate]="tooltipTemplate"
      [rtTooltipEnabled]="showShareSum"
      [text]="sharedAdminCount + sharedContainerCount"
      color="counter-default"
      margin-left-small-xx
      data-cy="candidate-sharing-button:counter"
    />
  }
</rt-button>

<ng-template #tooltipTemplate>
  <div layout-vertical layout-align-items-center>
    @if (sharedAdminCount > 0) {
      <p>
        {{
          'app.candidate.share_dialog.team_members.shared_with_team_members'
            | translate: { count: sharedAdminCount }
        }}
      </p>
    }
    @if (sharedContainerCount > 0) {
      <p>
        {{
          'app.candidate.share_dialog.team_members.shared_via_public_link'
            | translate: { count: sharedContainerCount }
        }}
      </p>
    }
  </div>
</ng-template>

<ng-template
  #sharingDropdown="rtConnectedOverlay"
  [origin]="dropdownTrigger"
  [positions]="dropdownPositions"
  rt-connected-overlay
  hasBackdrop
  (backdropClick)="sharingDropdown.open = false"
>
  <rt-candidate-sharing-dropdown
    #sharingDropdownComponent
    [candidateId]="candidateId()"
    [sharedAdminCount]="sharedAdminCount"
    [sharedContainerCount]="sharedContainerCount"
    (newItemClick)="newItemClick.emit()"
    data-cy="candidate-sharing-dropdown"
  />
</ng-template>
